import React, { useEffect, useState } from 'react'
import './App.css'
import { BrowserView, isSafari, MobileOnlyView, TabletView } from 'react-device-detect'
import Desktop from './pages/Desktop/Desktop'
import Mobile from './pages/Mobile/Mobile'

const App: React.FC = () => {
    const [orientation, setOrientation] = useState<string>('portrait')

    useEffect(() => {
        if (window.innerHeight > window.innerWidth) {
            setOrientation('portrait')
        } else {
            setOrientation('landscape')
        }
        window.addEventListener('orientationchange', () => {
            if (window.innerHeight > window.innerWidth) {
                setOrientation('portrait')
            } else {
                setOrientation('landscape')
            }
        })

        return () => {
            window.removeEventListener('orientationchange', () => {
                return
            })
        }
    }, [])

    if (isSafari) {
        if (window.innerWidth > 750) {
            return <Desktop />
        }
        return <Mobile />
    }

    return (
        <>
            <BrowserView>
                <Desktop />
            </BrowserView>
            <TabletView>{orientation === 'landscape' ? <Desktop /> : <Mobile />}</TabletView>
            <MobileOnlyView>
                <Mobile />
            </MobileOnlyView>
        </>
    )
}

export default App
